Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anyResetMap = void 0;

var self_blockquote_reset_1 = require("./self-blockquote-reset");

var self_code_reset_1 = require("./self-code-reset");

var self_hr_reset_1 = require("./self-hr-reset");

var self_list_reset_1 = require("./self-list-reset");

var self_pre_reset_1 = require("./self-pre-reset");

var self_strong_reset_1 = require("./self-strong-reset");

var self_table_reset_1 = require("./self-table-reset");

var a_link_reset_1 = require("./a-link-reset");

var button_reset_1 = require("./button-reset");

var heading_reset_1 = require("./heading-reset");

var paragraph_reset_1 = require("./paragraph-reset");

exports.anyResetMap = {
  a: a_link_reset_1.aLinkReset,
  blockquote: self_blockquote_reset_1.selfBlockquoteReset,
  button: button_reset_1.buttonReset,
  code: self_code_reset_1.selfCodeReset,
  h1: heading_reset_1.heading1Reset,
  h2: heading_reset_1.heading2Reset,
  h3: heading_reset_1.heading3Reset,
  h4: heading_reset_1.heading4Reset,
  h5: heading_reset_1.heading5Reset,
  h6: heading_reset_1.heading6Reset,
  hr: self_hr_reset_1.selfHrReset,
  ul: self_list_reset_1.selfListReset,
  ol: self_list_reset_1.selfListReset,
  li: self_list_reset_1.selfListReset,
  p: paragraph_reset_1.paragraphReset,
  pre: self_pre_reset_1.selfPreReset,
  strong: self_strong_reset_1.selfStrongReset,
  table: self_table_reset_1.selfTableReset
};